import styled from "@emotion/styled";
import { useTheme } from "@mui/material";
import { Skeleton } from "@kaltura/mediaspace-shared-styled";

const StyledTitleSkeleton = styled("div")(({ theme }) => ({
    marginTop: theme.spacing(1),
    maxWidth: "45%",
}));

const StyledSkeleton = styled(Skeleton)(({ theme }) => ({
    borderRadius: theme.kaltura.shape.roundness1,
}));

/**
 * media-page title-area skeleton
 */
export function TitleSkeleton() {
    const theme = useTheme();

    return (
        <StyledTitleSkeleton>
            <StyledSkeleton variant="rectangular" height={theme.spacing(4)} width={"100%"} />
        </StyledTitleSkeleton>
    );
}

export default TitleSkeleton;
